import React from "react";
import ToolMenuIconButton from "../../common/ToolMenuIconButton";
import { BsTrash } from "react-icons/bs";

export interface IProps {
  onClick?: () => void;
}

class DeleteButton extends React.Component<IProps> {
  render(): JSX.Element {
    return (
      <ToolMenuIconButton
        icon={<BsTrash />}
        tooltip="Delete"
        onClick={this.props.onClick}
      />
    );
  }
}

export default DeleteButton;
